import {BookingOriginEnum} from '../constants/bookingOriginEnum';
import {BookingTypeEnum} from '../constants/bookingTypeEnum';
import {BookingFlowType, FlowEnum} from '../constants/flowEnum';

const getBookingTypeAndOrigin = (flowType: BookingFlowType) => {
	if (flowType === FlowEnum.EXAM)
		return {
			bookingType: BookingTypeEnum.EXAM,
			bookingOrigin: BookingOriginEnum.BOOKING_EXAM,
		};

	if (flowType === FlowEnum.ODONTO) {
		return {
			bookingType: BookingTypeEnum.ODONTO,
			bookingOrigin: BookingOriginEnum.BOOKING_ODONTO,
		};
	}

	if (flowType === FlowEnum.TELEHEALTH)
		return {
			bookingType: BookingTypeEnum.TELEHEALTH,
			bookingOrigin: BookingOriginEnum.BOOKING_TELEHEALTH,
		};

	return {
		bookingType: BookingTypeEnum.HEALTH,
		bookingOrigin: BookingOriginEnum.BOOKING_HEALTH,
	};
};

export {getBookingTypeAndOrigin};
